import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DashboardAuthenticationGuard } from './guards/dashboard-authentication.guard';
import { LoginAuthenticationGuard } from './guards/login-authentication.guard';
import { LoginComponent } from './login/login.component';
import { PanelComponent } from './panel/panel.component';

const routes: Routes = [
  {
    path: 'panel/:id',
    component: PanelComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate : [LoginAuthenticationGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canActivate: [DashboardAuthenticationGuard]
  },
  {
    path: '',
    redirectTo : 'dashboard/graphy',
    pathMatch : 'full'
  },
  {
    path: '**',
    redirectTo : 'dashboard/graphy',
    pathMatch : 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
